import React from 'react';
import { Container, Typography, Box, Grid, Paper, Button } from '@mui/material';
import './Admission.css'; // Importando o arquivo CSS específico

const Admission = () => {
  return (
    <Container className="admission-container">
      <Box mb={6} mt={20} textAlign="center" className="admission-header">
        <Typography variant="h2" component="h1" gutterBottom>
          Processo de Admissão
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary">
          Seja bem-vindo à nossa escola! Estamos ansiosos para recebê-lo em nossa comunidade.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper elevation={3} className="admission-paper">
            <Typography variant="h4" component="h2" gutterBottom>
              Inscrição
            </Typography>
            <Typography variant="body1" component="p" gutterBottom>
              O primeiro passo para ingressar em nossa escola é preencher o formulário de inscrição online. Isso nos permitirá conhecer melhor o candidato e suas necessidades.
            </Typography>
            <Button variant="contained" color="primary" href="/inscricao">
              Preencher Formulário
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} className="admission-paper">
            <Typography variant="h4" component="h2" gutterBottom>
              Visita Guiada
            </Typography>
            <Typography variant="body1" component="p" gutterBottom>
              Convidamos você e sua família para uma visita guiada em nossa escola. Durante a visita, você conhecerá nossas instalações e poderá tirar todas as suas dúvidas.
            </Typography>
            <Button variant="contained" color="primary" href="/visita-guiada">
              Agendar Visita
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={3} className="admission-paper">
            <Typography variant="h4" component="h2" gutterBottom>
              Requisitos de Admissão
            </Typography>
            <Typography variant="body1" component="p" gutterBottom>
              Para ser admitido em nossa escola, o candidato deve cumprir os seguintes requisitos:
            </Typography>
            <ul>
              <li>Ter idade mínima de 5 anos.</li>
              <li>Preencher o formulário de inscrição.</li>
              <li>Participar da entrevista de admissão.</li>
              <li>Apresentar documentação necessária (certidão de nascimento, comprovante de residência, etc.).</li>
            </ul>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Admission;
